import { ApiError } from '@/lib/api';

/**
 * Extract a user-facing message from a thrown value. Returns the `ApiError`
 * message when the error came from the API client, otherwise the `fallback`.
 *
 * This is the inline-error-display counterpart to the toast humanization in
 * `lib/toast.ts` (which additionally maps machine codes and suppresses 401s).
 * Use this where a component owns its own error UI; use the toast helpers when
 * the error should surface as a snackbar.
 */
export function getErrorMessage(err: unknown, fallback: string): string {
  if (err instanceof ApiError) return err.message;
  return fallback;
}
